var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"text-center"},[_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }